import { useOutletContext, useParams } from "react-router-dom";

import db from "astrid-firebase/src/db";
import useDocumentDataOnce from "astrid-firestore/src/hooks/useDocumentDataOnce";

import LoadingContext from "../../ui/components/LoadingContext/LoadingContext";
import Unauthorized from "../../ui/components/Unauthorized/Unauthorized";

import useHasRight from "../../authorization/hooks/useHasRight";

import PrepareAgreementsView from "../views/PrepareAgreementsView/PrepareAgreementsView";

export default function PrepareAgreements() {
	const { templateId } = useParams();
	const { organization } = useOutletContext();

	const hasRight = useHasRight();

	const [agreement, loading, error] = useDocumentDataOnce(templateId && db.collection("agreements").doc(templateId));

	if (!hasRight("agreements.send")) {
		return <Unauthorized />;
	}

	return (
		<LoadingContext loading={loading} error={error}>
			<PrepareAgreementsView
				agreement={agreement}
				templateId={agreement?.template?.id || templateId}
				organization={organization}
			/>
		</LoadingContext>
	);
}
